import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

import { ContextProvider as PolicyTemplatesProvider } from 'components/Common/PolicyTemplates/Context';
import PolicyPlanTemplateContext from '../../../contexts/PolicyPlanTemplateContext';
import Create from './Create/Create';
import Edit from './Edit/Edit';
import List from './List/Index';
import PageTitleNew from '../../ui/PageTitleNew';

export default function Index() {
  const [typeView, setTypeView] = useState('list');

  return (
    <PolicyPlanTemplateContext>
      <PolicyTemplatesProvider>
        {typeView == 'edit' && (
        <Edit
          onSuccessCreate={() => setTypeView('list')}
          onCancel={() => setTypeView('list')}
        />
        )}
        {typeView == 'create' && (
        <Create
          onSuccessCreate={() => setTypeView('list')}
          onCancel={() => setTypeView('list')}
        />
        )}
        {typeView == 'list' && (
        <div className="wrapper_assestment invite_wrapper">
          <PageTitleNew title="Policy Templates" />

          <div className="ibox-content mt20">
            <Row>
              <Col md={12} className="text-right">
                <Button onClick={() => setTypeView('create')} bsStyle="primary">
                  Add Template
                </Button>
              </Col>
            </Row>

            <List setTypeView={setTypeView} />
          </div>
        </div>
        )}
      </PolicyTemplatesProvider>
    </PolicyPlanTemplateContext>
  );
}
